<template>
    <div class="main-container">
      <div class="container">
        <!-- Header Section -->
        <div class="row">
          <div class="col-lg-12 text-center my-4">
            <h1>Privacy Policy</h1>
            
          </div>
        </div>
  
        
        <div class="row">
          <div class="col-lg-12">
            <strong>Lingkup</strong>
            <p class="text-white">
            Pemberitahuan Privasi ini berlaku untuk informasi, termasuk informasi pribadi, yang diperoleh oleh Cenderawasih Juara Manajemen tentang Anda.
            </p>
            <strong>Informasi Pribadi</strong>
            <p class="text-white">
              <ol class="text-white">
               <li>Kami menggunakan informasi yang kami peroleh untuk menyediakan produk dan jasa yang Anda minta, untuk menginformasikan kepada Anda tentang produk dan jasa yang ditawarkan oleh Cenderawasih Juara Manajemen, dan untuk mengelola Situs Web dan jasa kami.</li>
               <li>Kami dapat menggabungkan informasi yang kami peroleh dari Anda dengan informasi yang kami peroleh dari sumber lainnya untuk membantu kami meningkatkan keakuratan dan kelengkapan secara keseluruhan, dan untuk membantu memperbaiki interaksi kami dengan Anda.</li>
               <li>Selain itu, kami juga dapat memperoleh informasi terkait penggunaan Anda atas Situs Web kami melalui penggunaan berbagai teknologi, termasuk cookies.</li>
              </ol>
           
            </p>
            <strong>Penggunaan  / Pembagian Informasi</strong>
            <p class="text-white">
            Kami tidak menjual atau mengungkapkan informasi pribadi pengunjung Situs Web kami, kecuali sebagaimana disebutkan disini. 
            Kami dapat membagikan informasi yang diberikan oleh pengunjung kami pada www.cjmanajemen.co.id dengan para penyedia layanan yang kami sewa untuk melakukan layanan atas nama kami. Para penyedia layanan ini dibatasi oleh kontrak untuk menggunakan atau mengungkapkan informasi kecuali diperlukan untuk melakukan layanan atas nama kami atau untuk mematuhi persyaratan hukum. Selain itu, kami dapat mengungkapkan informasi tentang Anda (i) apabila kami diwajibkan secara hukum atau oleh proses hukum, (ii) kepada penegak hukum yang berwenang atau pejabat pemerintahan lainnya, atau (iii) ketika kami meyakini pengungkapan diperlukan atau tepat untuk mencegah cedera fisik atau kerugian finansial atau sehubungan dengan investigasi atas dugaan atau kegiatan ilegal yang terjadi. Kami mencadangkan hak kami untuk mengalihkan setiap informasi yang kami miliki tentang Anda dalam hal kami menjual atau mengalihkan semua atau sebagian usaha atau aset kami. Dalam hal penjualan atau pengalihan tersebut terjadi, kami akan berupaya sewajarnya untuk mengarahkan penerima pengalihan untuk menggunakan informasi pribadi yang telah Anda berikan melalui Situs Web ini dengan cara yang konsisten dengan Pernyataan Privasi ini.
            </p>
            <strong>Perubahan atas Kebijakan Privasi kami</strong>
            <p class="text-white">
            Kami dapat mengubah Kebijakan Privasi ini dari waktu ke waktu dengan menampilkan versi terkini dari Kebijakan Privasi dalam Situs Web Cenderawasih Juara Manajemen. Kami akan memberikan pemberitahuan sewajarnya atas setiap perubahan materiil. Kami menganjurkan Anda untuk mengunjungi secara rutin agar tetap terinformasikan mengenai cara bagaimana kami menggunakan informasi pribadi Anda.
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PrivacyPolicyPage',
  };
  </script>
  
  <style scoped>
  
  
  .schedule-table {
    width: 100%;
    margin-top: 20px;
    border-color: #444; /* Darker border color */
  }
  
  .table {
    background-color: #181818; /* Dark table background */
    color: #fff; /* White text for table content */
  }
  
  .table thead {
    background-color: #333; /* Slightly darker header for the table */
  }
  
  .table tbody tr:hover {
    background-color: #444; /* Dark gray background on hover */
  }
  </style>
  